import Card from "components/card";

const Widget = ({ icon, title, subtitle, titleClass, subTitleClass, extra }) => {
  return (
    <Card extra={`widget-card ${extra}`}>
      { icon && 
      <div className="ml-[18px] flex h-[90px] w-auto flex-row items-center">
        <div className="rounded-full bg-lightPrimary p-3 dark:bg-intsamis-700">
          <span className="flex items-center text-theme-500 dark:text-white">
            {icon}
          </span>
        </div>
      </div>
      }

      <div className="h-[70px] ml-4 flex w-full flex-col justify-center pr-5">
        <p className={`main-title ${titleClass}`}>{title}</p>
        <h4 className={`sub-title ${subTitleClass}`}>
          {subtitle}
        </h4>
      </div>
    </Card>
  );
};

export default Widget;
